export default "__VITE_ASSET__cf895b29__"